<script>
  import {
    ListGroup,
    ListGroupItem,
    Container,
    Card,
    CardBody,
    InputGroup,
    Input,
    InputGroupAddon,
    Button,
    Spinner,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
  } from "sveltestrap";

  import { Doc } from "sveltefire";

  import { onMount } from "svelte";

  import {
    uniqueNamesGenerator,
    adjectives,
    colors,
    animals
  } from "unique-names-generator";

  import Fa from "svelte-fa";
  import {
    faBomb,
    faShareAlt,
    faInfoCircle,
    faCheck,
    faFileUpload,
    faArrowRight,
    faEnvelopeOpenText
  } from "@fortawesome/free-solid-svg-icons";

  import ChatScroll from "./ChatScroll.svelte";
  import Destroyed from "./Destroyed.svelte";

  import ClipboardJS from "clipboard";

  export let chatSession;
  export let firebase;
  export let openChat;

  let messageToSend;
  let shared = false;
  let sendMsgBtn;
  let fileUploading = false;
  let openInfo = false;

  const userName = uniqueNamesGenerator({
    dictionaries: [adjectives, animals],
    length: 2,
    separator: " ",
    style: "capital"
  });

  const sendMsg = chatRef => {
    messageToSend = messageToSend.replace(/\s+/g, " ").trim();
    if (messageToSend !== "" && messageToSend !== null && messageToSend !== " ")
      chatRef.update({
        messages: firebase.firestore.FieldValue.arrayUnion({
          user: userName,
          message: messageToSend,
          time: new Date()
        })
      });
    messageToSend = "";
  };

  const destroy = () => {
    const db = firebase.firestore();
    db.collection("chats")
      .doc(chatSession)
      .delete()
      .catch(function(error) {
        console.error("Error removing document: ", error);
      });
    openChat = false;
  };

  const share = () => {
    console.info("Your room code: " + chatSession);
    new ClipboardJS("#shareButton");
    document.getElementById("shareButton").click();
    shared = true;
    setTimeout(() => {
      shared = false;
    }, 2000);
  };

  const upload = () => {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.click();
    fileSelector.onchange = async () => {
      fileUploading = true;

      const file = fileSelector.files[0];
      const data = new FormData();
      const fetchOptions = {
        method: "POST",
        body: data
      };

      if (/^image/.test(file.type)) {
        data.append("key", "bf57525d00673259d5593bb2f6840e42");
        data.append("image", file);

        const rawResponse = await fetch(
          `https://api.imgbb.com/1/upload`,
          fetchOptions
        );

        const response = await rawResponse.json();
        const fileUrl = response.data.url;
        const displayUrl = response.data.display_url;

        messageToSend = `<a href="${fileUrl}" target="_blank"><img src="${displayUrl}" class="img-fluid" style="max-height: 280px; width: auto;"></a>`;
      } else {
        const rawResponse = await fetch("https://apiv2.gofile.io/getServer");
        const response = await rawResponse.json();
        const server = response.data.server;
        data.append("filesUploaded", file);

        const rawResponse2 = await fetch(
          `https://${server}.gofile.io/upload`,
          fetchOptions
        );

        const response2 = await rawResponse2.json();
        const fileUrl = `<a href="https://gofile.io/d/${response2.data.code}" target="_blank" style="color: #212529">${file.name} ↓</a>`;

        messageToSend = fileUrl;
      }

      sendMsgBtn.click();
      fileUploading = false;
    };
    return false;
  };

  const toggleInfo = () => (openInfo = !openInfo);

  const reqNotif = () => {
    if (Notification.permission === "granted") showNotifs = true;
    else
      Notification.requestPermission().then(p => {
        if (p === "granted") showNotifs = true;
      });
  };
</script>

<style>

</style>

<Container fluid class="vh-100 py-3">
  <Card class="mx-auto text-white h-100" color="dark">
    <CardBody class="d-flex h-100" style="flex-flow: column;">
      <Doc path={`chats/${chatSession}`} let:data={chat} let:ref={chatRef}>

        <div class="h-100" slot="fallback">
          <Destroyed />
        </div>

        <div class="mb-2">
          <h2 class="float-left">Eph Chat</h2>
          <div class="float-right h-auto">
            <Button
              outline
              color="warning"
              class="align-middle"
              on:click={() => reqNotif()}>
              <Fa icon={faEnvelopeOpenText} />
            </Button>
            <Button
              outline
              color="success"
              id="shareButton"
              data-clipboard-text={chatSession}
              on:click={() => share()}>
              {#if !shared}
                <Fa icon={faShareAlt} />
              {:else}
                <Fa icon={faCheck} />
              {/if}
            </Button>
            <Button
              outline
              color="info"
              class="align-middle"
              on:click={toggleInfo}>
              <Fa icon={faInfoCircle} />
            </Button>
            <Button
              outline
              color="danger"
              class="align-middle"
              on:click={() => destroy()}>
              <Fa icon={faBomb} />
            </Button>
          </div>
        </div>

        <Modal
          isOpen={openInfo}
          toggle={toggleInfo}
          class="modal-dialog-centered">
          <ModalHeader toggle={toggleInfo} class="bg-dark">
            About Eph Chat
          </ModalHeader>
          <ModalBody class="bg-dark">
            Welcome to Eph Chat!
            <br />
            <br />
            By the nature of how this is built, your chats are technically not
            private. Each chat is assigned a random, 28 character code
            consisting of letters and numbers which is provided to you via the
            share button. If someone was to random enter your code (1 in
            1.5×10⁵⁰), they would exist like any other participant. So, be
            careful.
            <br />
            <br />
            If you didn't read the big red warning when joining, you should
            really delete your chats. If you don't delete your chat, it won't
            get deleted. And by the same extension, there is no undo. Once a
            chat is delted, it's gone, except for images and links. Those will
            all remain live.
          </ModalBody>
          <ModalFooter class="bg-dark">
            <Button color="primary" on:click={toggleInfo}>Close</Button>
          </ModalFooter>
        </Modal>

        <ChatScroll {chat} {userName} />

        <div>
          <InputGroup>
            <Input
              name="roomCode"
              placeholder="Type a message"
              bind:value={messageToSend}
              on:keyup={e => {
                e.preventDefault();
                if (e.key === 'Enter') sendMsg(chatRef);
              }} />
            <InputGroupAddon addonType="append">
              {#if fileUploading}
                <Button class="btn-block" color="primary">
                  <Spinner color="light" size="sm" />
                </Button>
              {:else}
                <Button
                  class="btn-block"
                  color="primary"
                  on:click={() => upload()}>
                  <Fa icon={faFileUpload} />
                </Button>
              {/if}
            </InputGroupAddon>
            <InputGroupAddon addonType="append">
              <button
                type="button"
                class="btn btn-success btn-block"
                on:click={() => sendMsg(chatRef)}
                bind:this={sendMsgBtn}>
                <Fa icon={faArrowRight} />
              </button>
            </InputGroupAddon>
          </InputGroup>
        </div>
      </Doc>
    </CardBody>
  </Card>
</Container>
